define("settings/controllers/subscription/billing/tax-id", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@ember/utils", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _utils, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let BillingTaxIdController = _exports.default = (_class = class BillingTaxIdController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _defineProperty(this, "handleRouteWillChange", transition => {
        this.confirmRouteChange.perform(transition);
      });
      _defineProperty(this, "confirmRouteChange", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (transition) {
          if (this.taxIdChangeset?.isDirty) {
            transition.abort();
            const didConfirm = yield this.confirmClose();
            if (didConfirm) {
              this.taxIdChangeset.rollback();
              transition.retry();
            }
          }
        }
      }), null, "confirmRouteChange", "drop"));
      _defineProperty(this, "onTaxIdFormSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.billingController.onTaxIdFormSubmit.perform();
        }
      }), null, "onTaxIdFormSubmit", "drop"));
    }
    get canApplyTaxId() {
      const textFields = ['businessName', 'taxId'];
      const hasTextFieldChanged = textFields.some(key => Object.keys(this.taxIdChangeset?._changes ?? {}).includes(key));
      return Boolean(this.taxIdChangeset?.isDirty && this.taxIdChangeset?.isValid && (0, _utils.isPresent)(this.taxIdChangeset?.taxId) && (0, _utils.isPresent)(this.taxIdChangeset?.businessName) && hasTextFieldChanged && this.taxIdChangeset?.didConfirm == true && !this.isTaxIdPending);
    }
    get taxIdChangeset() {
      return this.billingController.taxIdChangeset;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get isLoadingTaxId() {
      return this.billingController.isLoadingTaxId;
    }
    get isSavingTaxId() {
      return this.onTaxIdFormSubmit.isRunning || this.billingController.didSaveTaxId && this.isTaxIdPending;
    }
    get isTaxIdPending() {
      return this.billingController.isTaxIdPending;
    }
    async closeTaxIdForm() {
      if (this.taxIdChangeset?.isDirty) {
        const didConfirm = await this.confirmClose();
        if (didConfirm) {
          this.taxIdChangeset.rollback();
          this.router.transitionTo('account.subscription.billing');
        }
      } else {
        this.router.transitionTo('account.subscription.billing');
      }
    }
    async confirmClose() {
      return await this.dialogManager.confirmation(this.intl.t('account.subscription.billing.tax.confirm.title'), {
        description: this.intl.t('account.subscription.billing.tax.confirm.description'),
        confirmButton: this.intl.t('shared_words.discard')
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeTaxIdForm", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTaxIdForm"), _class.prototype)), _class);
});